import translate from '@/utils/translate';

// eslint-disable-next-line import/prefer-default-export
export function portfolioStepIncompleteMessage({
  hasProfilePicture,
  hasCoverPhoto,
}: {
  hasProfilePicture: boolean;
  hasCoverPhoto: boolean;
}): string {
  if (!hasProfilePicture && !hasCoverPhoto) {
    return translate(
      'Add a profile photo and at least one cover photo to continue'
    );
  }
  if (!hasProfilePicture) {
    return translate('Add a profile photo to continue');
  }
  return translate('Add at least one cover photo to continue');
}
